"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTestLoggerUtils = getTestLoggerUtils;
function getTestLoggerUtils() {
    const loggerMock = {
        level: 'error',
        name: 'test',
        error: jest.fn(),
        info: jest.fn()
    };
    function expectLogged(logMethod, ...msgs) {
        expect(logMethod).toHaveBeenCalledWith(expect.stringMatching(new RegExp(`(.*)${msgs.join('(.*)')}(.*)`)), expect.anything());
    }
    function expectErrorLogged(...msgs) {
        expectLogged(loggerMock.error, ...msgs);
    }
    function expectInfoLogged(...msgs) {
        expectLogged(loggerMock.info, ...msgs);
    }
    return {
        loggerMock,
        expectErrorLogged,
        expectInfoLogged
    };
}
//# sourceMappingURL=testUtils.js.map